/**
 * Restrict affiliate portal pages to users with an existing affiliate account.
 * Applicants without an account can still use the overview, application and
 * dispute pages, which handle that state explicitly. Account status and risk
 * restrictions remain authoritative in the individual backend operations.
 */
export default defineNuxtRouteMiddleware(async () => {
  const profile = await useAffiliateAPI().profile()
  if (profile) return

  const localePath = useLocalePath()
  return navigateTo(localePath('/cuenta/afiliados'))
})
